<div class="container-fluid">
    <div class="row" *ngIf="modoEdicion">
        <div class="col-12 p-3 text-right" style="text-align: right;">
            <button class="btn btn-primary ml-2 mr-2" (click)="actualizarContenido()">
                <svg [cIcon]="icons.cilSave" size="xl" title="Guardar" style="color: white !important;"></svg>
            </button>
        </div>
        <div class="col-12">
            <form class="w-100" [formGroup]="formContent">
                <div class="NgxEditor__Wrapper">
                    <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
                    <ngx-editor [editor]="editor" [placeholder]="'Type here...'"
                        formControlName="contenido"></ngx-editor>
                </div>
            </form>
        </div>
    </div>
    <div class="row" *ngIf="!modoEdicion">
        <div class="col-12" [innerHTML]="html">
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <form [formGroup]="form" class="form-horizontal" cForm>
                <div class="form-group">
                    <label for="nombre">Nombre y apellido</label>
                    <input type="text" name="nombre" id="nombre" class="form-control" placeholder="Nombre"
                        formControlName="nombres">
                </div>
                <div class="form-group">
                    <label for="Correo">Correo</label>
                    <input type="email" name="Correo" id="Correo" class="form-control" placeholder="Correo"
                        formControlName="correo">
                </div>
                <div class="form-group">
                    <label for="Mensaje">Mensaje</label>
                    <textarea name="Mensaje" id="Mensaje" cols="30" rows="10" style="width: 100%;" formControlName="mensaje"></textarea>
                    <small id="mensajehelp" class="text-muted">Ingrese minimo 10 caracteres.</small>
                </div>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">
            <button class="btn btn-primary btn-continuar" (click)="guardar()" [disabled]="form.invalid">Enviar</button>
        </div>
    </div>
</div>